import React from "react";

export function DeleteIcon() {
  return (
    <>
      <i className="far fa-trash-alt"></i>
    </>
  );
}
